class NetworkMonitor {
  private static instance: NetworkMonitor;
  private wasOffline: boolean = false;

  private constructor() {
    this.initialize();
  }

  public static getInstance(): NetworkMonitor {
    if (!NetworkMonitor.instance) {
      NetworkMonitor.instance = new NetworkMonitor();
    }
    return NetworkMonitor.instance;
  }

  private initialize(): void {
    // Set initial state
    this.wasOffline = !navigator.onLine;

    // Listen for online/offline events
    window.addEventListener('online', () => {
      console.log('Network connection restored');
      if (this.wasOffline) {
        console.log('Network was previously offline, refreshing page');
        window.location.reload();
      }
      this.wasOffline = false;
    });

    window.addEventListener('offline', () => {
      console.log('Network connection lost');
      this.wasOffline = true;
    });
  }
}

export const networkMonitor = NetworkMonitor.getInstance(); 